import { useEffect, useState } from "react";

import useWarehouseLocations from "../../data/useWarehouseLocations";
import useWilmaUsers from "../../data/useWilmaUsers";
import { IWarehouseLocation } from "../../models/Location";
import formatDateTime from "../../utils/formatDateTime";

export default function WarehouseLocationFromId({
  id,
  lastKnownId,
  lastStockChecked,
  locatedById,
}: {
  id: string | null;
  lastKnownId?: string | null;
  lastStockChecked?: string | null;
  locatedById?: string | null;
}) {
  const { warehouseLocations } = useWarehouseLocations();
  const { wilmaUsers } = useWilmaUsers();
  const [location, setLocation] = useState<IWarehouseLocation | undefined>(undefined);
  const [lastKnownLocation, setLastKnownLocation] = useState<IWarehouseLocation | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [locatedBy, setLocatedBy] = useState<string | null>(null);

  useEffect(() => {
    if (!warehouseLocations.isLoading && warehouseLocations.data) {
      setLocation(warehouseLocations.data.data.find((l) => l.id === id));
      setLastKnownLocation(warehouseLocations.data.data.find((l) => l.id === lastKnownId));
      setLoading(false);
    }
  }, [warehouseLocations.data, warehouseLocations.isLoading, id, lastKnownId]);

  useEffect(() => {
    if (locatedById && !wilmaUsers.isLoading && wilmaUsers.data) {
      const user = wilmaUsers.data.data.find((user) => user.id === locatedById);
      setLocatedBy(user ? user.fullname : "Unknown User");
    }
  }, [locatedById, wilmaUsers.data, wilmaUsers.isLoading]);

  if (loading) {
    return <span>Loading...</span>;
  }

  return (
    <div>
      {location ? (
        <span>{location.displayName}</span>
      ) : lastKnownLocation ? (
        <span className="text-gray-400 italic">
          No location — last seen: {lastKnownLocation.displayName}
        </span>
      ) : (
        <span>Not set</span>
      )}
      {lastStockChecked && <p className="text-xs text-gray-700">Last Stock Checked: {formatDateTime(lastStockChecked)}</p>}
      {locatedBy && <p className="text-xs text-gray-700">Located By: {locatedBy}</p>}
    </div>
  );
}
